<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Promotions
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-code-index' })">
            <i class="fa fa-ticket"></i> Code
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ title }}</h3>
          </div>
        </div>

        <div class="box-body" style="overflow: unset;">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">
              <div class="form-horizontal">
                <div class="form-group">
                  <label for="promo-start-date"
                    class="col-sm-3 control-label">
                    Start Date <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.start_date"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-date"
                    class="col-sm-3 control-label">
                    End Date <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.end_date"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-time"
                    class="col-sm-3 control-label">
                    Start-End Time <span class="req">*</span>
                  </label>

                  <div class="col-sm-3">
                    <input
                      disabled
                      v-model="form.start_time"
                      type="text"
                      class="form-control"
                    >
                  </div>

                  <div class="col-sm-3">
                    <input
                      disabled
                      v-model="form.end_time"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-date"
                    class="col-sm-3 control-label">
                    Promo Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      style="text-transform: uppercase"
                      v-model="form.code"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">Product Name</label>

                  <div class="col-sm-9">
                    <v-select
                      multiple
                      name="product"
                      placeholder="Select Product"
                      v-model="form.product_id"
                      :options="list.products"
                      disabled
                    ></v-select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="promo-name-badges" class="col-sm-3 control-label">Badges</label>

                  <div class="col-sm-9">
                    <v-select
                      multiple
                      name="badges"
                      placeholder="Select Product Badges"
                      v-model="form.badges"
                      :options="list.badges"
                      disabled
                    ></v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">Destination</label>

                  <div class="col-sm-9">
                    <treeselect
                      placeholder="Select Product Destination"
                      v-model="form.destination_id"
                      sort-value-by="LEVEL"
                      :value-consists-of="'ALL_WITH_INDETERMINATE'"
                      id="form"
                      ref="destinationOption"
                      :multiple="true"
                      :options="list.destinations"
                      :default-expand-level="2"
                      :auto-load-root-options="true"
                      disabled
                    ></treeselect>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-date"
                    class="col-sm-3 control-label">
                    Promo Payments
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      style="text-transform: uppercase"
                      v-model="form.promo_config_name"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-date"
                    class="col-sm-3 control-label">
                    Type <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.type"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-date"
                    class="col-sm-3 control-label">
                    Nominal <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <div class="input-group">
                      <span class="input-group-addon" id="nominal">
                        {{ nominalPrefix }}
                      </span>
                      <input
                        disabled
                        v-model="form.nominal"
                        type="text"
                        class="form-control"
                       >
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="form.type === 'nominal'">
                  <label for="promo-min-pay-amount"
                    class="col-sm-3 control-label">
                    Min. Pay Amount <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.minimum_pay_amount"
                      type="number"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-max-pay-amount"
                    class="col-sm-3 control-label">
                    Max. Promo Disc. <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.maximum_amount"
                      type="number"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-quota" class="col-sm-3 control-label">
                    Quota
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-3">
                    <input
                      v-model="form.quota"
                      type="number"
                      min="1"
                      id="promo-quota"
                      name="promo-quota"
                      class="form-control"
                      placeholder="Quota (0 = Unlimited)"
                      disabled
                    />
                  </div>

                  <div class="col-sm-3">
                    <input
                      type="checkbox"
                      v-model="form.isUnlimitedQuota"
                      disabled
                    /> Unlimited Quota
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-quota" class="col-sm-3 control-label">
                    Daily Quota
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-3">
                    <input
                      v-model="form.daily_quota"
                      type="number"
                      min="1"
                      id="promo-quota"
                      name="promo-quota"
                      class="form-control"
                      placeholder="Daily Quota (0 = Unlimited)"
                      disabled
                    />
                  </div>

                  <div class="col-sm-3">
                    <input
                      type="checkbox"
                      v-model="form.isUnlimitedDailyQuota"
                      disabled
                    /> Unlimited Daily Quota
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-min-payment"
                    class="col-sm-3 control-label">
                    Min. Payment <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.minimum_payment"
                      type="number"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-media"
                    class="col-sm-3 control-label">
                    Applicable To <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <label class="checkbox-inline" v-for="item in form.media">
                      <input
                        disabled
                        type="checkbox"
                        :id="item"
                        :value="item"
                        v-model="form.media"
                      >
                      {{ item }}
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-available" class="col-sm-3 control-label">
                    Available To
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <label class="checkbox-inline" v-for="item in availables" :for="item.value">
                      <input
                        type="checkbox"
                        :id="'available_to_' + item.value"
                        :value="item.value"
                        v-model="form.available_to"
                        disabled
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="restriction"
                    class="col-sm-3 control-label">
                    Restriction
                  </label>
                  <div class="col-sm-9">
                    <v-select
                      disabled
                      v-model="form.restriction"
                      :multiple="true">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="is-locked-domain" class="col-sm-3 control-label">
                    Is Locked Domain
                  </label>

                  <div class="col-sm-9">
                    <label class="radio-inline">
                      <input
                        disabled
                        type="radio"
                        :value="1"
                        v-model="form.is_locked_domain"
                      />
                      Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        disabled
                        type="radio"
                        :value="0"
                        v-model="form.is_locked_domain"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="locked-domains" class="col-sm-3 control-label">Locked Domains</label>

                  <div class="col-sm-9">
                    <input
                      disabled
                      v-model="form.locked_domains"
                      :multiple="true"
                      class="form-control"
                      placeholder="Separated by comma (,)">
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-description"
                    class="col-sm-3 control-label">
                    Description <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <textarea
                      disabled
                      v-model="form.description"
                      type="text"
                      class="form-control"
                    >
                    </textarea>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Status <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      disabled
                      v-model="form.is_enabled"
                      :options="statuses">
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <a class="btn btn-default pull-right"
            @click.prevent="back">
            Back
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import moment from 'moment';
  import Common from '@/mixins/Common';
  import flatten from 'lodash/flatten';
  import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';

  export default {
    name: 'PromoCodeView',

    mixins: [Common],

    data() {
      return {
        title: 'View Promo Code',

        form: {
          promo_detail_id: null,
          promo_config_name: null,
          code: null,
          start_date: null,
          end_date: null,
          start_time: '00:00:00',
          end_time: '23:59:59',
          config: null,
          type: null,
          nominal: null,
          maximum_amount: null,
          minimum_pay_amount: null,
          minimum_payment: null,
          quota: null,
          daily_quota: null,
          media: [],
          restriction: [],
          recurring_type: 'none',
          recurring_date: null,
          recurring_day: [],
          is_enabled: {
            label: 'Active',
            value: 1,
          },
          isUnlimitedQuota: null,
          isUnlimitedDailyQuota: null,
          available_to: [],
          locked_domains: null,
          created_by: null,
          hide_installment: false,
          product_id: null,
          category_id: null,
          badges: null,
          destination_id: null,
          description: null,
        },

        list: {
          products: [],
          destinations: [],
          flatDestinations: [],
          categories: [],
          badges: [],
        },

        params: {
          page: 1,
          perpage: 500,
        },

        statuses: [
          {
            label: 'Active',
            value: 1,
          },
          {
            label: 'Inactive',
            value: 0,
          },
        ],
        availables: [
          {
            label: 'All',
            value: 'all',
            disabled: false,
          },
          {
            label: 'Member',
            value: 'member',
            disabled: false,
          },
        ],

        nominalPrefix: 'IDR',
      };
    },

    components: {
      Treeselect,
    },

    methods: {
      async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.destinationListUpdated) {
          await this.getAvailableDestination();
          this.destinationListUpdated = false;
        }
      }
    },
      parseDate(date, to) {
        if (!date) return '';
        const formatTo = to || 'YYYY-MM-DD';
        return moment(date).format(formatTo);
      },

      back() {
        this.$router.go(-1);
      },

      fetch() {
        this.axios.get(`/promo-code/${this.$route.params.id}`)
          .then((response) => {
            const { data } = response.data;

            this.form.start_date = this.parseDate(data.start_date, 'DD MMM YYYY');
            this.form.end_date = this.parseDate(data.end_date, 'DD MMM YYYY');
            this.form.start_time = data.start_time;
            this.form.end_time = data.end_time;
            this.form.code = data.code;
            this.form.promo_config_name = data.promo_config_name;
            this.form.type = data.detail.type;
            this.form.quota = data.quota;
            this.form.daily_quota = data.daily_quota;
            this.form.nominal = data.detail.nominal;
            this.form.maximum_amount = data.detail.maximum_amount;
            this.form.minimum_pay_amount = data.detail.minimum_pay_amount;
            this.form.minimum_payment = data.detail.minimum_payment;
            this.form.description = data.detail.description;
            this.form.is_locked_domain = data.detail.is_locked_domain;
            this.form.locked_domains = data.detail.locked_domains;

            if (data.quota === 0) {
              this.form.isUnlimitedQuota = true;
            }

            if (data.daily_quota === 0) {
              this.form.isUnlimitedDailyQuota = true;
            }

            if (data.detail.type === 'percentage') {
              this.nominalPrefix = '%';
            }

            if (data.detail.media) {
              this.form.media = data.detail.media.split(',');
            }

            if (data.detail.restriction) {
              this.form.restriction = data.detail.restriction.split(',');
            }

            if (data.detail.badges) {
              const badgesData = data.detail.badges.map(item => ({
                label: item.name,
                value: item.id,
              }));
              this.form.badges = badgesData;
            }
            
            const productsData = [];
            if (data.detail.product_id) {
              const arrayProducts = data.detail.product_id.split(',');
              console.log(arrayProducts);
              arrayProducts.forEach((selected) => {
                this.list.products.forEach((item) => {
                  if (item.value === parseInt(selected, 10)) {
                    productsData.push(item);
                  }
                });
              });
              console.log(productsData);
            }

            const categoriesData = [];
            if (data.detail.category_id) {
              const arrayCategory = data.detail.category_id.split(',');
              arrayCategory.forEach((selected) => {
                this.list.categories.forEach((item) => {
                  if (item.value === parseInt(selected, 10)) {
                    categoriesData.push(item);
                  }
                });
              });
            }
            const arrayDestination = data.detail.destinations;
            if (arrayDestination) {
              const valueDestinations = arrayDestination
              .filter(l => !arrayDestination.find(val => l.id === val.parent_id))
              .map(l => l.id);
              this.form.destination_id = valueDestinations;
            } else {
              this.form.destination_id = null;
            }
            const availableData = [];
            if (data.available_to === 'all') {
              availableData.push('all', 'member');
              this.availables[1].disabled = true;
            } else {
              availableData.push('member');
            }
            this.form.product_id = productsData;
            this.form.category_id = categoriesData;
            this.form.available_to = availableData;

            if (data.is_enable === 0) {
              this.form.is_enabled = {
                label: 'Inactive',
                value: 0,
              };
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              this.errors = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: 'Failed to fetch promo code detail',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetch();
                }
              });
            }
          });
      },

      fetchItem(type) {
      return new Promise((resolve) => {
        let endpoint = type;
        if (type === 'products') {
          endpoint = 'products-only';
        }
        this.axios
          .get(`/${endpoint}`, { params: this.params })
          .then((response) => {
            const { data } = response.data;
            const results = data.map(item => ({
              label: item.name,
              value: item.id,
            }));
            this.list[type] = results;
            resolve(data);
          })
          .catch((error) => {
            console.log(`Fetch ${type} error`, error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: `Failed to fetch available ${type}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchItem(type);
                }
              });
            }
          });
      });
      },

      async getAvailableDestination() {
        const destinations = await this.fetchItem('destinations');
        this.list.destinations = await this.generate(destinations);
        this.list.flatDestinations = await this.flattenDestination(destinations);
      },

      flattenDestination(data) {
        const result = [];

        data.forEach((parent) => {
          result.push({
            id: parent.id,
            label: parent.name,
          });

          if (parent.child !== null) {
            parent.child.forEach((child) => {
              result.push({
                id: child.id,
                label: child.name,
              });

              if (child.child) {
                child.child.forEach((grandchild) => {
                  result.push({
                    id: grandchild.id,
                    label: grandchild.name,
                  });
                });
              }
            });
          }
        });

        return flatten(result);
      },

      generate(data) {
        if (!data) return [];

        return data.map((local) => {
          if (local.child) {
            return {
              id: local.id,
              label: local.name,
              isDefaultExpanded: true,
              children: local.child.map((parent) => {
                if (parent.child) {
                  return {
                    id: parent.id,
                    label: parent.name,
                    children: parent.child.map((child) => {
                      if (child.child) {
                        return {
                          id: child.id,
                          label: child.name,
                          children: child.child.map(grandchild => ({
                            id: grandchild.id,
                            label: grandchild.name,
                          })),
                        };
                      }
                      return {
                        id: child.id,
                        label: child.name,
                      };
                    }),
                  };
                }

                return {
                  id: parent.id,
                  label: parent.name,
                };
              }),
            };
          }

          return {
            id: local.id,
            label: local.name,
          };
        });
      },
      async init() {
        await this.fetchItem('products');
        await this.fetchItem('badges');
        await this.fetchItem('categories');
        await this.getAvailableDestination();
        this.fetch();
      },
    },

    created() {
      this.init();
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/modules/promo/code/View.vue